const isTextMatchTerm = (text = "", term = "")=>{
    return text.toLowerCase().trim().indexOf(term.toLowerCase().trim()) !== -1;
};
const isTitleLineMatchTerm = (titleLine, term)=>{
    if (!titleLine || !titleLine.text) {
        return false;
    }
    return isTextMatchTerm(titleLine.text, term) || isTextMatchTerm(titleLine.decorator, term);
};
export const itemFilterValidator = (item, term)=>{
    const { firstTitle, secondTitle } = item.props;
    return isTitleLineMatchTerm(firstTitle, term) || isTitleLineMatchTerm(secondTitle, term);
};
